export function usePagePath(pageKey: string) {
  const route = useRoute()
  const embeddedPageKeyPrefix = 'embedded-'

  if (route.meta.embedded) {
    pageKey = embeddedPageKeyPrefix + pageKey
  }

  return getPagePath[pageKey]![route.params.locale as string]
}
